import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

//************* EVALUACION  ***************************/

import { ActividadService } from '../../../../shared/services/evaluacion/actividad/actividad.service';
import { AreaService } from '../../../../shared/services/evaluacion/area/area.service';
import { ComponenteService } from '../../../../shared/services/evaluacion/componente/componente.service';

import { EncuestaService } from '../../../../shared/services/evaluacion/encuesta/encuesta.service';
import { EvaluacionPersonaHetService } from '../../../../shared/services/evaluacion/evaluacionPersonaHet/evaluacionPersonaHet.service';
import { PonderacionService } from '../../../../shared/services/evaluacion/ponderacion/ponderacion.service';
import { PreguntaService } from '../../../../shared/services/evaluacion/pregunta/pregunta.service';
import { ResultadoCabService } from '../../../../shared/services/evaluacion/resultadoCab/resultadoCab.service';
import { ResultadoConsolidadoService } from '../../../../shared/services/evaluacion/resultadoConsolidado/resultadoConsolidado.service';
import { ResultadoDetService } from '../../../../shared/services/evaluacion/resultadoDet/resultadoDet.service';
import { TipoPreguntaService } from '../../../../shared/services/evaluacion/tipoPregunta/tipoPregunta.service';
import { UnidadService } from '../../../../shared/services/evaluacion/unidad/unidad.service';
import { ValoracionService } from '../../../../shared/services/evaluacion/valoracion/valoracion.service';
import { ValoracionRangosService } from '../../../../shared/services/evaluacion/valoracionRangos/valoracionRangos.service';

import { evaluacionPersonaCoevService } from '../evaluacionPersonaCoev/evaluacionPersonaCoev.service';
import { EvaluacionResultadoCoevaluacionCabService } from '../evaluacionResultadoCoevaluacionCab/evaluacionResultadoCoevaluacionCab.service';
import { EvaluacionResultadoCoevaluacionConsolidadoService } from '../evaluacionResultadoCoevaluacionConsolidado/evaluacionResultadoCoevaluacionConsolidado.service';
import { EvaluacionResultadoCoevaluacionDetService } from '../evaluacionResultadoCoevaluacionDet/evaluacionResultadoCoevaluacionDet.service';

import { credencialesGeneradasHeteroevaluacionService } from '../credencialesGeneradasHeteroevaluacion/credencialesGeneradasHeteroevaluacion.service';
import { DedicacionService } from '../dedicacion/dedicacion.service';
import { HorasDedicacionService } from '../horasDedicacion/horasDedicacion.service';
import { ActividadesSustancialesService } from '../actividadesSustanciales/actividadesSustanciales.service';
import { HorasDedicacionDetalleService } from '../horasDedicacionDetalle/horasDedicacionDetalle.service';
import { ResultadoCoevaluacionCabService } from '../resultadoCoevaluacionCab/resultadoCoevaluacionCab.service';
import { Interceptor } from '../../token/interceptor';
import { UiteyCodigosSimilitudesPsqlService } from '../uiteyCodigosSimilitudesPsql/uiteyCodigosSimilitudesPsql.service';
import { EvaluacionPersonaImpugnacionCoevService } from '../evaluacionPersonaImpugnacionCoev/evaluacionPersonaImpugnacionCoev.service';
import { CredencialesGeneradasCoevaluacionService } from '../credencialesGeneradasCoevaluacion/credencialesGeneradasCoevaluacion.service';
import { PreguntaActividadService } from '../preguntaActividad/preguntaActividad.service';
import { EvaluacionPersonaRecalcularCoevService } from '../evaluacionPersonaRecalcularCoev/evaluacionPersonaRecalcularCoev.service';


//************************************ COEVALUACION ***********************************/




@NgModule({
  imports: [
    CommonModule
  ],
  declarations: []
})
export class SharedEvaluacionModule {
  static forRoot(): ModuleWithProviders<SharedEvaluacionModule> {
    return {
      ngModule: SharedEvaluacionModule,
      providers: [

        ActividadService, AreaService, ComponenteService, credencialesGeneradasHeteroevaluacionService,
        EncuestaService, EvaluacionPersonaHetService, PonderacionService, PreguntaService,
        ResultadoCabService, ResultadoConsolidadoService, ResultadoDetService, TipoPreguntaService,
        UnidadService, ValoracionService, ValoracionRangosService, evaluacionPersonaCoevService,
        EvaluacionResultadoCoevaluacionCabService, EvaluacionResultadoCoevaluacionConsolidadoService,
        EvaluacionResultadoCoevaluacionDetService, CredencialesGeneradasCoevaluacionService,
        DedicacionService,PreguntaActividadService,EvaluacionPersonaRecalcularCoevService,
        HorasDedicacionService, ActividadesSustancialesService, HorasDedicacionDetalleService,
        ResultadoCoevaluacionCabService, UiteyCodigosSimilitudesPsqlService, EvaluacionPersonaImpugnacionCoevService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: Interceptor,
          multi: true
        }]
    };
  }
}
